import React, { useState } from "react";
import {
  Card,
  DataTable,
  Thumbnail,
  Button,
  InlineStack,
  Text,
} from "@shopify/polaris";
import ConfirmationModal from "../Common/ConfirmationModal";
import { DeleteBundle } from "../../services/bundle";
import { useNavigate } from "react-router-dom";
import { PAGE_SIZE } from "../../constants/common-constants";

const BundleTable = ({
  bundles,
  fetchBundles,
  fetchBundleOverview,
  currentPage,
  setCurrentPage,
}) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedBundle, setSelectedBundle] = useState(null);

  const handleDeleteClick = (bundle) => {
    setSelectedBundle(bundle);
    setModalOpen(true);
  };
  function capitalizeEachWord(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const handleConfirmDelete = async () => {
    if (selectedBundle) {
      try {
        // Call your API to delete the bundle
        await DeleteBundle(selectedBundle._id);
      } catch (error) {
        console.error("Error deleting bundle:", error);
      } finally {
        fetchBundles();
        fetchBundleOverview();
        setModalOpen(false);
        setSelectedBundle(null);
      }
    }
  };
  const handleUpdate = async (id) => {
    navigate(`/bundles/update/${id}`);
  };

  const rows = bundles.map((bundle) => [
    <Thumbnail
      source={bundle?.coverImage?.url}
      alt={bundle.name}
      size="small"
    />,
    <div
      style={{
        maxWidth: "200px",
        whiteSpace: "normal",
        wordBreak: "break-word",
      }}
    >
      {capitalizeEachWord(bundle.name)}
    </div>,
    // bundle.sku,
    capitalizeEachWord(bundle.status),
    `₹${bundle.price}`,
    `${bundle.compareAtPrice ? `₹${bundle.compareAtPrice}` : "-"}`,
    <InlineStack align="space-between">
      <Button size="slim" onClick={() => handleUpdate(bundle._id)}>
        View
      </Button>
      <Button size="slim" destructive onClick={() => handleDeleteClick(bundle)}>
        Delete
      </Button>
    </InlineStack>,
  ]);

  return (
    <Card>
      <DataTable
        hideScrollIndicator
        columnContentTypes={[
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
        ]}
        headings={[
          <Text variant="headingSm"></Text>,
          <Text variant="headingSm">Bundle Name</Text>,
          // <Text variant="headingSm">SKU</Text>,
          <Text variant="headingSm">Status</Text>,

          // <Text variant="headingSm">Quantity</Text>,
          <Text variant="headingSm"> Price</Text>,
          <Text variant="headingSm">Compare At Price</Text>,
          <Text variant="headingSm"> Actions</Text>,
        ]}
        rows={rows}
        pagination={{
          hasNext: bundles?.length >= PAGE_SIZE,
          onNext: () => {
            setCurrentPage(currentPage + 1);
          },
          onPrevious: () => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          },
          hasPrevious: currentPage > 1,
        }}
      />
      {modalOpen && selectedBundle && (
        <ConfirmationModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handleConfirmDelete}
          title="Confirm Deletion"
          message={`Are you sure you want to delete the bundle "${selectedBundle.name}"? This action cannot be undone.`}
        />
      )}
    </Card>
  );
};

export default BundleTable;
